import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { agentFormDefault } from "@factory/form/form.default";
import { AgentFormRule, AgentFormSchema } from "@factory/form/form.rule";
import { useQyCreateAgent } from "@factory/query/agent.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewAgent() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateAgent } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Agent is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addAgent, isLoading: isCreating } =
    useQyCreateAgent(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<AgentFormSchema>({
    defaultValues: agentFormDefault,
    resolver: zodResolver(AgentFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: AgentFormSchema) => {
    const formData = mapCreateAgent(form);
    addAgent(formData);
  };
  const handleValidateError = (err: FieldErrors<AgentFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
